/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { LookupSourceArtistResponseMembersInner } from './LookupSourceArtistResponseMembersInner';
import {
    LookupSourceArtistResponseMembersInnerFromJSON,
    LookupSourceArtistResponseMembersInnerFromJSONTyped,
    LookupSourceArtistResponseMembersInnerToJSON,
} from './LookupSourceArtistResponseMembersInner';

/**
 * 
 * @export
 * @interface LookupSourceArtistResponse
 */
export interface LookupSourceArtistResponse {
    /**
     * 
     * @type {string}
     * @memberof LookupSourceArtistResponse
     */
    stageName: string;
    /**
     * 
     * @type {boolean}
     * @memberof LookupSourceArtistResponse
     */
    isGroup: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof LookupSourceArtistResponse
     */
    _exists: boolean;
    /**
     * 
     * @type {string}
     * @memberof LookupSourceArtistResponse
     */
    internalId?: string | null;
    /**
     * 
     * @type {Array<LookupSourceArtistResponseMembersInner>}
     * @memberof LookupSourceArtistResponse
     */
    members: Array<LookupSourceArtistResponseMembersInner>;
}

/**
 * Check if a given object implements the LookupSourceArtistResponse interface.
 */
export function instanceOfLookupSourceArtistResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "stageName" in value;
    isInstance = isInstance && "isGroup" in value;
    isInstance = isInstance && "_exists" in value;
    isInstance = isInstance && "members" in value;

    return isInstance;
}

export function LookupSourceArtistResponseFromJSON(json: any): LookupSourceArtistResponse {
    return LookupSourceArtistResponseFromJSONTyped(json, false);
}

export function LookupSourceArtistResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): LookupSourceArtistResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'stageName': json['stageName'],
        'isGroup': json['isGroup'],
        '_exists': json['exists'],
        'internalId': !exists(json, 'internalId') ? undefined : json['internalId'],
        'members': ((json['members'] as Array<any>).map(LookupSourceArtistResponseMembersInnerFromJSON)),
    };
}

export function LookupSourceArtistResponseToJSON(value?: LookupSourceArtistResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'stageName': value.stageName,
        'isGroup': value.isGroup,
        'exists': value._exists,
        'internalId': value.internalId,
        'members': ((value.members as Array<any>).map(LookupSourceArtistResponseMembersInnerToJSON)),
    };
}

